var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebtpayoffGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.63,22.3,89.87,7.7a2,2,0,0,1,2.62,1.08l8.17,19.75,1.54,3.69L110.37,52a2,2,0,0,1-1.08,2.61L74.05,69.17",
    fill: "#d1f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.63,22.3,89.87,7.7a2,2,0,0,1,2.62,1.08l8.17,19.75,1.54,3.69L110.37,52a2,2,0,0,1-1.08,2.61L74.05,69.17",
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 61.11,
    y1: 37.93,
    x2: 98.2,
    y2: 22.57,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.05,69.17,38.81,83.77a2,2,0,0,1-2.62-1.08L28,63l-1.53-3.7L18.31,39.51a2,2,0,0,1,1.08-2.61L54.63,22.3",
    fill: "#d1f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,69.17,38.81,83.77a2,2,0,0,1-2.62-1.08L28,63l-1.53-3.7L18.31,39.51a2,2,0,0,1,1.08-2.61L54.63,22.3",
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 24.02,
    y1: 53.29,
    x2: 61.11,
    y2: 37.93,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.88,98.39a11.66,11.66,0,1,1-10.78,7.2,11.63,11.63,0,0,1,10.78-7.2m0-6.48a18.14,18.14,0,1,0,6.93,1.38,18.15,18.15,0,0,0-6.93-1.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.63 117 58.55 106.95 66.73 87.2 76.72 82.98 62.63 117"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.04 38.07 103.68 17.89 69.83 99.91 90.01 91.55 112.04 38.07",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80,34.45H53.43a2,2,0,0,0-2,2V83.19a2,2,0,0,0,2,2H80",
    fill: "#ffea80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,34.45H53.43a2,2,0,0,0-2,2V83.19a2,2,0,0,0,2,2H80",
    fill: "none",
    stroke: "#ffd500",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 51.37,
    x2: 51.43,
    y2: 51.37,
    fill: "none",
    stroke: "#ffd500",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "47.65 37.7 56.01 17.52 89.86 99.54 69.68 91.18 47.65 37.7",
    fill: "#666",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,98h0a11.67,11.67,0,1,1-4.46.89A11.64,11.64,0,0,1,113.8,98m0-6.48a18.15,18.15,0,1,0,16.77,11.2,18.08,18.08,0,0,0-16.77-11.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.04 116.64 101.3 106.52 93.12 86.77 82.95 82.62 97.04 116.64"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80,85.19h49.72a2,2,0,0,0,2-2V36.45a2,2,0,0,0-2-2H80",
    fill: "#ffea80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,85.19h49.72a2,2,0,0,0,2-2V36.45a2,2,0,0,0-2-2H80",
    fill: "none",
    stroke: "#ffd500",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 131.72,
    y1: 51.37,
    x2: 80,
    y2: 51.37,
    fill: "none",
    stroke: "#ffd500",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 98.15,
    x2: 80,
    y2: 117,
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 57.96,
    x2: 80,
    y2: 67.51,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeDasharray: "4 1 2 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtpayoffGoal);
export default __webpack_public_path__ + "static/media/debtpayoff-goal.e0a8573e.svg";
export { ForwardRef as ReactComponent };